module.exports = __webpack_public_path__ + "img/CRIT_AIR_2.f20b9d7a.png";